<style>
.preview-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 16px;
  margin-top: 20px;
}

.preview-grid>div {
  position: relative;
  width: 100%;
  aspect-ratio: 1 / 1;
  /* perfect square */
  border-radius: 12px;
  overflow: hidden;
  background: #f8f9fa;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.preview-grid>div:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.08);
}

.preview-grid img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  /* important */
  display: block;
}

.caption-form{
max-width:100%;
}

.input{
width:100%;
padding:10px;
border:1px solid #ddd;
border-radius:6px;
}

.preview img{
width:150px;
height:150px;
object-fit:cover;
border-radius:6px;
margin-top:10px;
}

</style>
<template>


  <!-- Content -->
  <div class="admin-content">

    <div class="d-flex align-items-center justify-content-between flex-wrap mb-3">
      <!-- Left -->
      <div>
        <h5 class="mb-0 fw-semibold text-color">Edit Product</h5>
        <p class="mb-0 text-muted small">
          Carefully Edit what you want
        </p>
      </div>
      <!-- Right -->
      <router-link :to="{ path: '/store' }" class="btn btn-primary">
        <span class="fas fa-arrow-left"> </span> Back Stores
      </router-link>
    </div>

    <div v-if="searching" class="mt-1">
      <div class="text-center">
        <div class="spinner-grow text-success" role="status"></div>
        <div class="spinner-grow text-danger" role="status"></div>
        <div class="spinner-grow text-warning" role="status"></div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-8 col-sm-12">
        <div class="card recent-orders-card mt-3">
          <!-- Card Header -->
          <div class="card-header d-flex justify-content-between align-items-center">
            <h6 class="mb-0 fw-semibold">
              <span class="text-color">Edit Info</span>
            </h6>
          </div>

          <!-- Card Body -->
          <div class="card-body p-0">

            <div class="p-3">

              <div class="row">
                <div class="col-md-12 col-sm-12 form-group mt-2">
                  <label class="text-muted mb-2" for="price">Product Name</label>
                  <input class="form-control w-100" type="text" v-model="form.title" id="">
                </div>

                <div class="col-md-6 col-sm-6 form-group mt-2">
                  <label class="text-muted mb-1" for="price">Category</label>
                  <select class="form-control w-100" v-model="form.category">
                    <option value="0" selected disabled>Select Category</option>
                    <option :value="cats.id" v-for="cats in categories" :key="cats.id">{{ cats.name }}</option>

                  </select>
                </div>

                <div class="col-md-6 col-sm-6 form-group mt-2">
                  <label class="text-muted mb-1" for="price">Visibility</label>
                  <select class="form-control w-100" v-model="form.status">
                    <option value="1">Visible</option>
                    <option value="0">Invisible</option>
                  </select>
                </div>

                <div class="col-md-12 col-sm-12 form-group mt-2">
                  <label class="text-muted mb-2" for="video">Youtube Link</label>
                  <input class="form-control w-100" type="text" v-model="form.video" id="">
                </div>

              </div>

              <div class="col-12 form-group mt-2">
                <label class="text-muted mb-2" for="price">Product Body</label>
                <!--textarea class="input-field w-100" v-model="form.body" rows="10" id=""></textarea-->
                 <QuillEditor
                  v-if="editorReady"
      v-model:content="form.body"
      contentType="html"
      theme="snow"
      style="height:300px"
      class="input-field"
    />
              </div>

              <p v-for="err in errors" class="text-danger mb-0">{{ err }}</p>
              <div class="form-group mt-3 mb-2">
                <button type="button" @click="updateProduct" class="btn-primary font-bold">
                  <i class="fas fa-check me-2"></i>
                  Update Product
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="col-md-4 col-sm-12">
        <div class="card recent-orders-card mt-3">
          <!-- Card Header -->
          <div class="card-header d-flex justify-content-between align-items-center">
            <h6 class="mb-0">
              <span class="text-color">Edit Prices</span>
            </h6>
          </div>

          <!-- Card Body -->
          <div class="card-body p-0">

            <div class="form-group p-3">
              <label class="text-muted mb-1" for="price">Main Price</label>
              <div class="d-flex gap-3 mb-3">
                <input @input="updateMainPrice()" class="form-control w-100" type="number" v-model="form.price" id="">
              </div>
              <div class="mt-2">
                <div class="d-flex gap-2">
                  <input v-model="discount_form.quantity" class="form-control w-30" type="number" placeholder="qnt"
                    name="" id="">
                  <input v-model="discount_form.percent" class="form-control w-30" type="number" placeholder="per%"
                    name="" id="">
                  <button @click="addDiscount" class="btn-primary w-20">+New</button>
                </div>

                <div class="d-flex justify-content-between gap-2 mt-4 border-top">
                  <span class="w-20 text-color">Qnt</span>
                  <span class="text-color">Per%</span>
                  <span class="w-40 text-color">Price</span>
                  <span class="w-40 text-color">Act</span>
                </div>
                <div v-for="item in price_option" :key="item.id"
                  class="d-flex justify-content-between gap-2 mt-2 border-top">
                  <span class="w-20 text-color">{{ item.quantity }}</span>
                  <span v-if="item.quantity == 1" class="w-20 text-color">{{ item.percent }} %</span>
                  <input v-if="item.quantity != 1" v-model="item.percent"
    @input="updateDiscount(item.quantity)" class="form-control" style="width: 60px;"
                    type="number" placeholder="" name="" id="">
                  <span class="w-40 text-color">
                    <PriceFormat :Price="item.price" />
                  </span>
                  <button v-if="item.quantity != 1" @click="removeDiscount(item.quantity, item.id)"
                    class="btn-danger-icon w-15">x</button>
                  <button v-if="item.quantity == 1" class="btn btn-default w-15">x</button>
                </div>
                <button @click="updateDBDiscount()" class="btn-primary mt-4"><i class="fas fa-check me-2"></i>Save Price
                  Changes</button>
              </div>
            </div>
          </div>
        </div>
      </div>

       <div class="col-md-12 col-sm-12">
        <div class="card recent-orders-card mt-3">
          <!-- Card Header -->
          <div class="card-header d-flex justify-content-between align-items-center">
            <h6 class="mb-0">
              <span class="text-color">Edit Contents</span>
            </h6>
            <div>
              <span class="text-color mr-2">{{ this.images.length }} / 7 Captions</span>
            <button v-if="this.images.length < 7" @click="addNewCoption()" data-bs-toggle="modal" data-bs-target="#addConfirm" class="btn-primary edit" title="Edit">
                                <i class="fas fa-plus"></i> New Caption
                              </button>
                              </div>
          </div>

          <!-- Card Body -->
          <div class="card-body p-0">

           <div class="table-responsive">
                <table class="table orders-table mb-0">
                  <thead class="">
                    <tr>

                      <th class="td-wd-product">THUMBNAIL</th>
                      <th class="">CAPTION</th>
                      <th class="text-end">ACTION</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr :class="'visible_'+product.status" v-for="product in images" :key="product.id">

                      <td class="text-color text-md">
                        <div class="align-items-center">
                          <img :src="this.$store.state.img_url + product.thumbnail" style="width: 200px; height:200px;" class="product-thumb" alt="">
                          <h6 class="text-md">ORDER : {{ product.orders }}</h6>
                        </div>
                      </td>
                      <td class="text-color text-bold text-sm">
                        <div>{{ product.body }}</div>
                       
                      </td>
                     
                      <td class="text-end text-sm">
                        <div class="order-actions">
                         <button @click="addConfirmModel(product)" data-bs-toggle="modal" data-bs-target="#addConfirm" class="order-action-btn text-primary edit" title="Edit">
                                <i class="fas fa-pen"></i> edit
                              </button>
                        </div>
                      </td>

                    </tr>

                  </tbody>
                </table>
              </div>
          </div>
        </div>
      </div>
    </div>

        <div class="modal fade" id="addConfirm" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false">

      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content custom-modal-style">

          <!-- HEADER -->
          <div class="modal-header custom-modal-header d-flex justify-content-between align-items-center">

            <h5 class="modal-title mb-0">Caption Create/Edit</h5>
            <button type="button" class="btn-close ms-3 text-white fas fa-xmark" data-bs-dismiss="modal">
            </button>
          </div>

          <!-- BODY -->
          <div class="modal-body custom-modal-body">
           
            <div class="caption-form">

  <!-- order -->
  <div class="form-group">
    <label for="">Order</label>
    <input v-if="caption.orders > 1"
      type="number"
      v-model="caption.orders"
      placeholder="Display Order"
      class="input form-control mt-2 mb-2"
      style="width:100px"
    >
    <input v-if="caption.orders == 1"
      type="number"
      value="1"
      disabled="true"
      class="input form-control mt-2 mb-2"
      style="width:100px"
    >
  </div>

  <!-- thumbnail upload -->
  <div class="form-group">

    <input type="file" class="form-control mt-2 mb-2" accept="image/*" @change="handleImage">

    <div v-if="preview" class="preview">
      <img :src="preview">
    </div>

  </div>

  <!-- body editor -->
  <div class="form-group">
     <label for="">Caption Body</label>
    <QuillEditor
      v-model:content="caption.body"
      contentType="html"
      theme="snow"
      style="height:300px"
    />
  </div>

  <button @click="submitForm" class="btn btn-primary m-4">
        <span class="fas fa-check"> </span> Save Caption
  </button>

</div>

          </div>

        </div>
      </div>
    </div>

  </div>
</template>
<script>
import axios from "axios";
import '@vueup/vue-quill/dist/vue-quill.snow.css'

import { QuillEditor } from "@vueup/vue-quill"
import PriceFormat from "@/components/PriceFormat.vue";

export default {
  components: {
    PriceFormat,
    QuillEditor
  },
  data() {
    return {
      searching: false,
       editorReady:false,
      errors: [],
      data: [],
      price: "",
      form: {
        title: "",
        price: 0,
        category: 0,
        body: "",
        status: 1,
        video: ""
      },
     preview:null,
caption:{
orders:'',
body:'',
thumbnail:null,
product_id:0,
og_thumb:null,
id:0
},
      discount_form: {
        percent: "",
        quantity: ""
      },
      product: {},
      images: [],
      price_option: [],
      categories: [],
      user: this.$attrs.user
    };
  },
  methods: {
        addConfirmModel(caption){
       this.caption = caption
       this.caption.og_thumb = caption.thumbnail
       this.preview = this.$store.state.img_url + caption.thumbnail
    },

     addNewCoption(){

      var caption = {
orders:this.images.length + 1,
body:'',
thumbnail:null,
og_thumb : null,
product_id:this.form.id,
id:0
}
       this.caption = caption
       this.preview = null
    },
    handleImage(e){

const file = e.target.files[0]
if(!file) return

const reader = new FileReader()

reader.onload = (event)=>{

const img = new Image()

img.onload = ()=>{

const canvas = document.createElement("canvas")
canvas.width = 600
canvas.height = 600

const ctx = canvas.getContext("2d")

ctx.drawImage(img,0,0,600,600)

canvas.toBlob((blob)=>{

this.caption.thumbnail = new File([blob],"thumb.jpg",{type:"image/jpeg"})

this.preview = URL.createObjectURL(blob)

},"image/jpeg",0.9)

}

img.src = event.target.result

}

reader.readAsDataURL(file)

},

async submitForm(){

if(!this.caption.orders || !this.caption.body){
alert("Fill all field orders and caption body")
return
}

if(this.caption.id == 0 && this.caption.thumbnail == null){
alert("Choose Image Files")
return
}


const formData = new FormData()

formData.append("orders",this.caption.orders)
formData.append("body",this.caption.body)
formData.append("id",this.caption.id)
formData.append("product_id",this.caption.product_id)
formData.append("og_thumb",this.caption.og_thumb)

if(this.caption.thumbnail){
formData.append("thumbnail",this.caption.thumbnail)
}

var response = await axios.post(this.$store.state.api_url + "/create-update-caption", formData, {
        headers: { "Content-Type": "multipart/form-data" }
      }).catch((errors) => {
        var message = "Network or Request Errors";
        //alert(message)
        this.$toast.error(message, { duration:5000, dismissible: true });
      });
      if (response.data.success) {
        //alert('Created successfully')

        window.location.reload()

      } else {
       
       
          var message = response.data.message
          this.$toast.error(message, { duration:5000, dismissible: true });
        
      }


},
    updateDiscount() {
      var price = this.form.price
      if (price == null || price == "") {
        alert("Add Price Above")
      } else {

        this.price_option = [{ quantity: 1, price, percent: 0 }]
      }
    },
    addDiscount() {

      var price_ = this.form.price

      var percent = this.discount_form.percent
      var quantity = this.discount_form.quantity
      var dicount = this.price_option

      var status = 1
      var updated_by = 0
      var product_id = this.form.id
      var id = 0

      if (percent == null || percent == "" || quantity == null || quantity == "") {
       
        this.$toast.error('give quantity and percent', { duration:5000, dismissible: true });
      } else {

        var price = ((price_ * quantity) - (((price_ * quantity) * percent) / 100))
        //var price = ((price_ * (quantity - 1)) + (price_ - (price_ * percent)/100))

        var newItem = { quantity, price, percent, status, updated_by, product_id, id }

        const exists = dicount.some(item => Number(item.quantity) === Number(newItem.quantity));

        if (exists) {
          
          this.$toast.error('Quantity already exists', { duration:5000, dismissible: true });
          return;
        }

        dicount.push(newItem)

        this.price_option = dicount

        this.discount_form.percent = ""
        this.discount_form.quantity = ""

      }
    },

    async removeDiscount(quantity, id) {

      var discounts = this.price_option

        if (id > 1) {
       
      const confirmAssign = window.confirm(
        `Are you sure you want to remove Discount?`
      );

      if (!confirmAssign) {
        //window.location.reload()
        return
      }else{

     
      // update status 
      var response = await axios.post(this.$store.state.api_url + "/remove-discount",{id})
      .catch((errors) => {
        var message = "Network or Request Errors";
        alert(message)
        //this.$toast.error(message, { duration:5000, dismissible: true });
      });
      if (response.data.success) {
       // alert('Cuccessfully')
        discounts = discounts.filter(function (obj) {
          return obj.quantity != quantity;
        });

        this.price_option = discounts

        //window.location.reload()
      } else {
        alert(response.data.message)
      }
    }

    
      } else {
        ///alert('Cant remove Original price')
         discounts = discounts.filter(function (obj) {
          return obj.quantity != quantity;
        });

        this.price_option = discounts
      }

    },
  async updateDBDiscount() {

      var discounts = this.price_option //JSON.stringify(this.price_option)
      var price = this.form.price
      var product_id = this.form.id

      const confirmAssign = window.confirm(
        `Are you sure you want to Update Discount?`
      );

      if (!confirmAssign) {
        //window.location.reload()
        return
      }else{

     
      // update status 
      var response = await axios.post(this.$store.state.api_url + "/update-discount",{discounts, product_id, price})
      .catch((errors) => {
        var message = "Network or Request Errors";
        //alert(message)
        this.$toast.error(message, { duration:5000, dismissible: true });
      });
      if (response.data.success) {

        var message = response.data.message
        this.$toast.success(message, { duration:5000, dismissible: true });

      } else {
      
         var message = response.data.message
        this.$toast.error(message, { duration:5000, dismissible: true });
      }
    }

    },
    updateDiscount(quantity) {

    const item = this.price_option.find(p => Number(p.quantity) === Number(quantity))

    if (!item) return

    var price_ = this.form.price
    const percent = Number(item.percent)

    var price = ((price_ * quantity) - (((price_ * quantity) * percent) / 100))

    item.price = price

  },

  updateMainPrice() {

    var price_ = this.form.price
    const discounts = this.price_option

    for (let index = 0; index < discounts.length; index++) {
      const item = discounts[index];

      var percent = item.percent
      var quantity = item.quantity

      var price = ((price_ * quantity) - (((price_ * quantity) * percent) / 100))

    item.price = price
      
    }

  },

    async updateProduct() {
      //alert('wel wel')

      const formData = new FormData()

      var name = this.form.title
      var category = this.form.category
      var body = this.form.body
      var status = this.form.status
      var video = this.form.video
      var product_id = this.form.id

      var response = await axios.post(this.$store.state.api_url + "/update/product", { name, category, body, status, video, product_id })
        .catch((errors) => {
          var message = "Network or Request Errors";
          //alert(message)
          this.$toast.error(message, { duration: 5000, dismissible: true });
        });
      if (response.data.success) {

        var message = response.data.message
        this.$toast.success(message, { duration: 5000, dismissible: true });
        //window.location.reload()

      } else {
          var message = response.data.message
          this.$toast.error(message, { duration: 5000, dismissible: true });

      }

    },
    async getProduct() {

      var product_id = this.$route.query.product_id;

      this.searching = true
      var response = await axios
        .post(this.$store.state.api_url + "/edit-product", { product_id })
        .catch((errors) => {
          this.searching = false
          var message = "Network or Server Errors";
          this.$toast.error(message, { duration: 5000, dismissible: true });
        });

      //console.log(response.data)
      if (response.data.success) {
        this.searching = false
         this.editorReady = true

        this.form = response.data.product;
        this.images = response.data.images;
        this.price_option = response.data.price_option;


      } else {
        this.searching = false
        var message = response.data.message;
        this.$toast.error(message, { duration: 5000, dismissible: true });
      }
    },
    async getCategories() {

      this.searching = true
      var response = await axios
        .get(this.$store.state.api_url + "/get-all-categories")
        .catch((errors) => {
          this.searching = false
          var message = "Network or Server Errors";
          this.$toast.error(message, { duration: 5000, dismissible: true });
        });

      //console.log(response.data)
      if (response.data.success) {
        this.searching = false
        this.categories = response.data.categories;

      } else {
        this.searching = false
        var message = response.data.message;
        this.$toast.error(message, { duration: 5000, dismissible: true });
      }
    },

  },
  computed: {
  },
  watch: {

  },
  created() {
    this.$store.state.page_name = "Store's"
    this.getCategories()
    this.getProduct()
  },
};


</script>
